import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import SignIn from "./SignIn";
import Popup2 from "./Popup2";
import { FaTimes } from "react-icons/fa";
import travelImage from "../../images/Travel.png";
import axios from "axios";

const Quiz = ({ onClose }) => {
  const { emailId, isLoggedIn, phoneNo, setAllVoted } = useContext(UserContext);
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [hasDataInDB, setHasDataInDB] = useState(false);
  const [showQuiz, setShowQuiz] = useState(true);
  const [showSignIn, setShowSignIn] = useState(!isLoggedIn);
  const [showConfirmExit, setShowConfirmExit] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);

  // Complete questions array with all 31 questions

  const questions = [
    {
      category: "Economic Stability",

      billTitle: "Appropriation Bill (No. 1)",

      question:
        "Do you support allocating over $500 billion from the federal budget to fund government operations including health, education, defence, aged care, social services, and infrastructure development?",

      subtext:
        "(Includes typical line items like Medicare, schools, pensions — but also significant defence funding and infrastructure grants.)",
    },

    {
      category: "Economic Stability",

      billTitle: "Appropriation Bill (No. 2)",

      question:
        "Do you support additional federal funding for items like grants to private sector programs, equity investments, and payments to international organisations, as part of the annual budget?",

      subtext:
        "(Funds include support for public-private partnerships, research grants, and international commitments such as the UN and WHO.)",
    },

    {
      category: "Health and Hospitals",

      billTitle:
        "Aged Care and Other Legislation Amendment (Royal Commission Response) Bill 2022",

      question:
        "Do you support implementing aged care reforms that include stronger oversight of providers, mandatory reporting on food and medication standards, and mandatory registration for all personal care workers?",

      subtext:
        "(These reforms respond to the Aged Care Royal Commission to improve safety, dignity, and quality of life in aged care facilities.)",
    },

    {
      category: "Health and Hospitals",

      billTitle: "Disability Services and Inclusion Bill 2023",

      question:
        "Do you support creating a new legal framework for disability inclusion that streamlines support services, ensures greater consultation with people with disabilities, and improves provider accountability?",

      subtext:
        "(This replaces outdated legislation with a more person-focused, inclusive model across government-funded disability services.)",
    },

    {
      category: "Crime Reduction & Law Enforcement",

      billTitle:
        "Crimes and Other Legislation Amendment (Omnibus No. 1) Bill 2023",

      question:
        "Do you support criminal law reforms that increase parole eligibility thresholds, tighten terrorism sentencing, expand firearm offences, and allow courts to consider extremist ideology during sentencing?",

      subtext:
        "(This bill covers multiple areas, with a focus on terrorism, weapons offences, and repeat offender policies.)",
    },

    {
      category: "Crime Reduction & Law Enforcement",

      billTitle:
        "Crimes and Other Legislation Amendment (Omnibus No. 2) Bill 2023",

      question:
        "Do you support updating laws to streamline the handling of crime proceeds, enhance anti-terrorism powers, tighten firearm controls, and improve national crime data sharing across agencies?",

      subtext:
        "(It includes new seizure powers, improved cooperation between law enforcement bodies, and firearm regulation updates.)",
    },

    {
      category: "Families with Children",

      billTitle:
        "Paid Parental Leave Amendment (Improvements for Families and Gender Equality) Bill 2022",

      question:
        "Do you support expanding paid parental leave by combining both parents' entitlements, allowing greater flexibility, and increasing access to support working families and promote gender equality?",

      subtext:
        "(Changes include 20 weeks of combined paid leave for both parents, the ability to take leave concurrently, and removal of the gender-based primary/secondary carer definitions.)",
    },

    {
      category: "Families with Children",

      billTitle:
        "Social Services Legislation Amendment (Child Support and Family Assistance Technical Amendments) Bill 2024",

      question:
        "Do you support making technical improvements to child support and family assistance laws to ensure more accurate payment calculations and reduce administrative delays?",

      subtext:
        "(Updates include improving income assessments, aligning provisions across different laws, and clarifying how shared care and reconciliation of debts are handled.)",
    },

    {
      category: "Affordable Housing",

      billTitle: "Housing Australia Future Fund Bill 2023",

      question:
        "Do you support establishing a $10 billion fund that invests in building 30,000 social and affordable homes over five years, with priority for women and veterans?",

      subtext:
        "(Earnings from the fund will finance new housing, with annual caps, and focus on vulnerable groups including women and children fleeing domestic violence and older Australians.)",
    },

    {
      category: "Affordable Housing",

      billTitle:
        "National Housing Finance and Investment Corporation Amendment (Unlocking Regional Housing) Bill 2023",

      question:
        "Do you support expanding a government housing finance agency's remit to directly fund infrastructure and housing projects in regional Australia?",

      subtext:
        "(The bill renames the agency to Housing Australia and allows it to fund roads, sewerage, and water systems that unlock housing supply in high-growth regional areas.)",
    },

    {
      category: "Better Business Conditions",

      billTitle:
        "Treasury Laws Amendment (Modernising Business Communications and Other Measures) Bill",

      question:
        "Do you support allowing companies to use digital tools like email and online platforms to communicate with shareholders and regulators instead of paper documents?",

      subtext:
        "(The bill modernises corporate communications by enabling digital notices, virtual meetings, and e-signatures while maintaining options for paper by request.)",
    },

    {
      category: "Better Business Conditions",

      billTitle:
        "Competition and Consumer Amendment (Fair Go for Consumers and Small Business) Bill",

      question:
        "Do you support tougher penalties and enforcement powers to deter anti-competitive behaviour and unfair practices against consumers and small businesses?",

      subtext:
        "(The bill increases maximum penalties for breaches of consumer and competition law, and expands ACCC powers to act against unfair contract terms and misconduct by big corporations.)",
    },

    {
      category: "Environmental and Energy Issues",

      billTitle: "Climate Change (Consequential Amendments) Bill 2022",

      question:
        "Do you support expanding the role of the Australian Renewable Energy Agency (ARENA) to help meet national climate goals, including greenhouse gas targets under the Paris Agreement?",

      subtext:
        "(This bill aligns existing energy legislation with the Climate Change Act 2022, giving ARENA broader authority to fund climate-related projects and enforce Australia's emissions reduction goals.)",
    },

    {
      category: "Environmental and Energy Issues",

      billTitle:
        "Environment Protection and Biodiversity Conservation Amendment (Climate Trigger) Bill 2022",

      question:
        "Do you support requiring environmental approvals for major projects to assess their greenhouse gas emissions and climate change impacts before going ahead?",

      subtext:
        "(Adds a 'climate trigger' to environmental law, ensuring projects emitting over 100,000 tonnes of CO₂ undergo federal climate impact assessments.)",
    },

    {
      category: "Fair Workplaces",

      billTitle:
        "Fair Work Legislation Amendment (Secure Jobs, Better Pay) Bill",

      question:
        "Do you support reforms to strengthen job security, restrict the use of fixed-term contracts, improve access to bargaining, and require pay transparency to help close the gender pay gap?",

      subtext:
        "(Includes limits on contract renewals, more powers for the Fair Work Commission, and new obligations for transparency on pay equity.)",
    },

    {
      category: "Fair Workplaces",

      billTitle:
        "Fair Work Legislation Amendment (Protecting Worker Entitlements) Bill",

      question:
        "Do you support changes to protect entitlements like redundancy pay, parental leave, superannuation, and enforceable unpaid parental leave disputes through the Fair Work Commission?",

      subtext:
        "(Also clarifies redundancy rights for small business transfers and includes superannuation in the National Employment Standards.)",
    },

    {
      category: "Rural Needs",

      billTitle:
        "Aboriginal Land Grant (Jervis Bay Territory) Amendment (Strengthening Land and Governance Provisions) Bill 2022",

      question:
        "Do you support updating land governance laws for the Wreck Bay Aboriginal community to clarify membership, improve meeting rules, and strengthen financial oversight?",

      subtext:
        "(Implements clearer governance procedures, eligibility definitions, and accountability mechanisms for managing Aboriginal land grants in Jervis Bay.)",
    },

    {
      category: "Lower Taxes for Families",

      billTitle:
        "Taxation (Multinational – Global and Domestic Minimum Tax) Bill 2024",

      question:
        "Do you support implementing a 15% global minimum tax on large multinational corporations to prevent profit shifting and ensure they contribute fairly to the Australian economy?",

      subtext:
        "(Applies to multinationals with annual global revenue over €750 million, aligning with OECD/G20 international tax reforms.)",
    },

    {
      category: "Lower Taxes for Families",

      billTitle:
        "Taxation (Multinational – Global and Domestic Minimum Tax) Imposition Bill 2024",

      question:
        "Do you support formally applying new tax charges to enforce the global and domestic minimum tax on multinationals operating in Australia?",

      subtext:
        "(This bill enables the actual imposition of the taxes created in the companion legislation, ensuring enforceability of the minimum rate.)",
    },

    {
      category: "Defence and Security",

      billTitle: "Counter-Terrorism and Other Legislation Amendment Bill 2023",

      question:
        "Do you support strengthening counter-terrorism laws by requiring police to inform detainees of their rights, tightening declaration powers, and improving oversight of terrorism responses?",

      subtext:
        "(Includes safeguards for declared terrorist zones, clearer detention protocols, and added reporting to improve transparency and accountability.)",
    },

    {
      category: "Defence and Security",

      billTitle:
        "Defence Amendment (Safeguarding Australia's Military Secrets) Bill 2023",

      question:
        "Do you support laws that prohibit former defence personnel and others from training or working for foreign militaries without approval, to protect national security?",

      subtext:
        "(Targets sensitive knowledge transfer, with penalties for unauthorized work or training involving military tactics, software, or defence goods.)",
    },

    {
      category: "Honest Government",

      billTitle: "National Anti-Corruption Commission Bill",

      question:
        "Do you support establishing a federal National Anti-Corruption Commission with powers to investigate serious misconduct by politicians and public servants?",

      subtext:
        "(Includes powers to hold public hearings, investigate retrospectively, and refer findings to relevant law enforcement agencies.)",
    },

    {
      category: "Honest Government",

      billTitle: "Lobbying (Improving Government Honesty and Trust) Bill",

      question:
        "Do you support tightening lobbying rules by requiring lobbyist registrations, a public meetings log, and a 5-year ban on ex-ministers lobbying former departments?",

      subtext:
        "(Aims to prevent conflicts of interest and increase public visibility into who is influencing government decisions.)",
    },

    {
      category: "Better Education",

      billTitle:
        "Higher Education Support Amendment (Australia's Economic Accelerator) Bill 2022",

      question:
        "Do you support providing government funding to help universities turn research into market-ready innovations, with oversight from an independent advisory board?",

      subtext:
        "(Supports commercialisation of university research in national priority areas through grants and investment planning by a dedicated advisory body.)",
    },

    {
      category: "Better Education",

      billTitle:
        "Higher Education Support Amendment (Response to the Australian Universities Accord Interim Report) Bill 2023",

      question:
        "Do you support requiring universities to implement student support policies and report annually on how they assist at-risk students in completing their studies?",

      subtext:
        "(Mandates formal support strategies and compliance reporting, especially targeting inclusion and retention of disadvantaged and Indigenous students.)",
    },

    {
      category: "Support for the Elderly",

      billTitle:
        "Social Services and Other Legislation Amendment (Incentivising Pensioners to Downsize) Bill 2022",

      question:
        "Do you support allowing pensioners to keep proceeds from selling their home exempt from the pension income test for longer, encouraging downsizing without losing pension entitlements?",

      subtext:
        "(Extends the asset test exemption from 12 to 24 months and adjusts income deeming rules, to help older Australians move into more suitable housing.)",
    },

    {
      category: "Reducing Migration",

      billTitle:
        "Migration Amendment (Strengthening the Character Test) Bill 2023",

      question:
        "Do you support giving the government more power to refuse or cancel visas for non-citizens convicted of offences like assault, weapons possession, or breaching court orders?",

      subtext:
        "(Introduces a new 'designated offence' category to broaden the definition of character concerns in visa decisions.)",
    },

    {
      category: "Reducing Migration",

      billTitle:
        "Migration Amendment (Strengthening Employer Compliance) Bill 2023",

      question:
        "Do you support harsher penalties and new criminal offences for employers who coerce or exploit migrant workers in breach of visa conditions?",

      subtext:
        "(Includes up to 2 years' jail and civil penalties, bans for repeat offenders, and increased regulatory powers to enforce workplace protections for migrants.)",
    },

    {
      category: "Reducing Unemployment",

      billTitle: "Jobs and Skills Australia Bill",

      question:
        "Do you support establishing a national agency to provide real-time advice on skills shortages and training needs across industries to inform government and business workforce planning?",

      subtext:
        "(Creates Jobs and Skills Australia as a central body to analyse labour trends and support long-term employment strategies.)",
    },

    {
      category: "Reducing Unemployment",

      billTitle: "Jobs and Skills Australia Amendment Bill",

      question:
        "Do you support enhancing Jobs and Skills Australia by replacing its Director with a Commissioner, adding Deputy Commissioners, and requiring an annual work plan with public consultation?",

      subtext:
        "(Introduces a formal governance structure and broader accountability measures to strengthen its role in national workforce planning.)",
    },

    {
      category: "Increasing Migration",

      billTitle: "Ending Indefinite and Arbitrary Immigration Detention Bill",

      question:
        "Do you support replacing mandatory indefinite immigration detention with time-limited, court-reviewed alternatives that uphold the rights of asylum seekers and non-citizens?",

      subtext:
        "(Sets maximum detention timeframes, mandates legal reviews, and prioritises community alternatives in line with international human rights standards.)",
    },
  ];

  const instructions = [
    "How important is it to choose a politician with Your Values at This Election?",
    "Only 31 Questions Stand Between You and Real Representation!",
    "Your Values. Your Leader. And a chance to Win a Holiday!",
  ];

  const handleAnswer = (questionNumber, answer) => {
    setAnswers((prev) => ({ ...prev, [questionNumber]: answer }));
  };

  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        const response = await fetch(`/api/quiz-answers?email_id=${emailId}`);
        if (response.ok) {
          const data = await response.json();
          if (data.answers?.length > 0) {
            setHasDataInDB(true);
            const answersObj = {};
            data.answers.forEach((ans) => {
              answersObj[ans.question_number] = ans.response;
            });
            setAnswers(answersObj);
          }
        }
      } catch (err) {
        console.error("Error fetching answers:", err);
      }
    };
    fetchAnswers();
  }, [emailId]);

  useEffect(() => {
    if (isLoggedIn) {
      setShowSignIn(false);
      setShowQuiz(false);
    } else {
      setShowSignIn(true);
      setShowQuiz(false);
    }
  }, [isLoggedIn]);

  const handleNextClick = async () => {
    if (currentStep === questions.length) {
      try {
        // Update quiz_finished status
        const response = await fetch("/api/update-quiz-status", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email_id: emailId }),
        });

        if (!response.ok) {
          console.error("Failed to update quiz status");
        }

        setAllVoted(true);
        setShowPopup2(true);
      } catch (error) {
        console.error("Error updating quiz status:", error);
        // Still show Popup2 even if the status update fails
        setAllVoted(true);
        setShowPopup2(true);
      }
    } else {
      try {
        await axios.post("/api/submit-eligible-vote", {
          bill: questions[currentStep - 1].billTitle,
          phoneNo,
          vote: answers[currentStep],
          type: "Federal",
          eligibility: "Yes",
          ageGroup: "1",
        });
      } catch (error) {
        console.log("Vote submission error:", error);
      }
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleClose = () => {
    // Show confirmation popup for both instruction page and quiz questions
    setShowConfirmExit(true);
  };

  const ConfirmExitPopup = () => (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        zIndex: 10000,
        textAlign: "center",
      }}
    >
      <h3 style={{ marginBottom: "20px" }}>
        Are you sure you want to lose the chance of winning prize?
      </h3>
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <button
          onClick={() => onClose()}
          style={{
            padding: "8px 20px",
            backgroundColor: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Yes, Exit
        </button>
        <button
          onClick={() => setShowConfirmExit(false)}
          style={{
            padding: "8px 20px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          No, Continue
        </button>
      </div>
    </div>
  );

  return (
    <>
      {showSignIn && (
        <SignIn
          onClose={() => {
            setShowSignIn(false);
            onClose();
          }}
          onSignInSuccess={() => {
            setShowSignIn(false);
            setShowQuiz(true);
          }}
        />
      )}
      {showPopup2 ? (
        <Popup2 onClose={onClose} />
      ) : (
        showQuiz &&
        isLoggedIn && (
          <div
            className="popup-section"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              className="popup-container"
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: "30px",
                width: "90%",
                maxWidth: "900px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                position: "relative",
                maxHeight: window.innerWidth <= 926 ? "80vh" : "90vh",
                overflowY: "auto",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              }}
            >
              <style>
                {`
                  .popup-container::-webkit-scrollbar {
                    display: none;
                  }
                `}
              </style>
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  zIndex: 1000,
                }}
              >
                <FaTimes
                  onClick={handleClose}  // Using handleClose for both instruction page and quiz questions
                  style={{ cursor: "pointer", fontSize: "24px", color: "#000" }}
                />
              </div>
              {currentStep === 0 ? (
                <div
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    marginTop: "30px",
                  }}
                >
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      marginBottom: "30px",
                    }}
                  >
                    {instructions.map((instruction, idx) => (
                      <li
                        key={idx}
                        style={{
                          marginBottom: "25px",
                          fontSize: "24px",
                          color: "#333",
                          fontWeight: "bold",
                          lineHeight: "1.4",
                          textShadow: "2px 2px 4px rgba(255, 255, 255, 0.7)",
                        }}
                      >
                        {instruction}
                      </li>
                    ))}
                  </ul>
                  <img
                    src={travelImage}
                    alt="Travel"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      marginBottom: "30px",
                      borderRadius: "10px",
                    }}
                  />
                  <button
                    onClick={() => setCurrentStep(1)}
                    style={{
                      padding: "12px 30px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      marginBottom: "20px"
                    }}
                  >
                    Start Quiz
                  </button>
                  <p style={{
                    color: "#dc3545",
                    fontSize: "20px",
                    fontStyle: "italic",
                    marginTop: "5px"
                  }}>
                    * Travel not included & nightly booking fees & {' '}
                    <a 
                      href="https://globalvacationreward.com/terms/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#dc3545',
                        textDecoration: 'underline'
                      }}
                    >
                      Terms & Conditions
                    </a>
                    {' '}apply.
                  </p>
                </div>
              ) : (
                <div className="quiz-container">
                  <div
                    style={{
                      marginBottom: "20px",
                      textAlign: "center",
                      color: "#666",
                    }}
                  >
                    Question {currentStep} of {questions.length}
                  </div>
                  <div
                    style={{
                      marginBottom: "20px",
                      textAlign: "center",
                      color: "#28a745",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {questions[currentStep - 1].category}
                  </div>
                  <div
                    style={{
                      marginBottom: "20px",
                      textAlign: "center",
                      color: "#333",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    {questions[currentStep - 1].billTitle}
                  </div>
                  <div
                    style={{
                      marginBottom: "15px",
                      fontSize: "18px",
                      color: "#333",
                      textAlign: "center",
                    }}
                  >
                    {questions[currentStep - 1].question}
                  </div>
                  {questions[currentStep - 1].subtext && (
                    <div
                      style={{
                        marginBottom: "30px",
                        fontSize: "14px",
                        color: "#666",
                        textAlign: "center",
                        fontStyle: "italic",
                      }}
                    >
                      {questions[currentStep - 1].subtext}
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "20px",
                      marginBottom: "40px",
                    }}
                  >
                    <button
                      onClick={() => handleAnswer(currentStep, "Yes")}
                      style={{
                        padding: "12px 40px",
                        backgroundColor:
                          answers[currentStep] === "Yes"
                            ? "#28a745"
                            : "#f8f9fa",
                        color:
                          answers[currentStep] === "Yes" ? "white" : "#333",
                        border: "1px solid #dee2e6",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      Yes
                    </button>
                    <button
                      onClick={() => handleAnswer(currentStep, "No")}
                      style={{
                        padding: "12px 40px",
                        backgroundColor:
                          answers[currentStep] === "No" ? "#dc3545" : "#f8f9fa",
                        color: answers[currentStep] === "No" ? "white" : "#333",
                        border: "1px solid #dee2e6",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      No
                    </button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "30px",
                      padding: "20px 0",
                      borderTop: "1px solid #dee2e6",
                    }}
                  >
                    <button
                      onClick={() => {
                        if (currentStep > 1) setCurrentStep((prev) => prev - 1);
                        else handleClose();
                      }}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      {currentStep === 1 ? "Exit" : "Previous"}
                    </button>
                    <button
                      onClick={handleNextClick}
                      disabled={!answers[currentStep]}
                      style={{
                        padding: '10px 20px',
                        backgroundColor: answers[currentStep] ? '#28a745' : '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: answers[currentStep] ? 'pointer' : 'not-allowed',
                        fontWeight: 'bold',
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      )}
      {showConfirmExit && <ConfirmExitPopup />}
    </>
  );
};

export default Quiz;
